export const update = (data) => ({
  type: "CUSTOM_DATA/UPDATE",
  payload: data,
});

export const clear = () => ({
  type: "CUSTOM_DATA/CLEAR",
  payload: {},
});
